import styled from 'styled-components';

export const StyledArticleList = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-5);

  @media (min-width: 786px) {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }
`;
